import { Component, OnInit } from '@angular/core';
import { InstacitiJSON4 } from '../instaciti-new.interface';
import { InstacitiNewService } from '../service/instaciti-new.service';

@Component({
  selector: 'portal-instaciti-popular-categories',
  templateUrl: './instaciti-popular-categories.component.html',
  styleUrls: ['./instaciti-popular-categories.component.css']
})
export class InstacitiPopularCategoriesComponent implements OnInit {
popularCategories:InstacitiJSON4[]
  constructor(private service:InstacitiNewService) { }

  ngOnInit(): void {
    this.service.instaSubject.subscribe((res)=>{
      if(res){
        this.popularCategories=this.service.getGlobalJson4();
      }
    })
  }

}
